/**
 * Cookie consent types for GDPR-compliant consent management
 */

/**
 * Categories of cookies/tracking that require consent
 */
export type ConsentCategory = "necessary" | "analytics" | "marketing";

/**
 * User's consent preferences for each category
 */
export interface ConsentPreferences {
  /** Essential cookies (always allowed, cannot be disabled) */
  necessary: true;
  /** Analytics and performance tracking (PostHog, etc.) */
  analytics: boolean;
  /** Marketing and advertising cookies */
  marketing: boolean;
}

/**
 * Stored consent state including metadata
 */
export interface ConsentState {
  /** User's consent preferences */
  preferences: ConsentPreferences;
  /** ISO timestamp when consent was given/updated */
  timestamp: string;
  /** Version of the consent format (for future migrations) */
  version: number;
}

/**
 * Default consent state - only necessary cookies allowed
 */
export const DEFAULT_CONSENT: ConsentPreferences = {
  necessary: true,
  analytics: false,
  marketing: false,
};

/**
 * Current consent storage version
 */
export const CONSENT_VERSION = 1;

/**
 * localStorage key for consent state
 */
export const CONSENT_STORAGE_KEY = "opm_consent";
